import {push, replace} from 'connected-react-router';
import {toast} from 'react-toastify';
import {deleteToken, getToken} from './auth';
import successMessages from './successMessages';
import errorMessages from './errorMessages';
import {DEV_MODE} from 'api';
import {getNotification} from './notifications/notifications';

export const onRequest = (request, requestAction, store) => {
  const token = getToken(store.getState());
  if (token) {
    if (!request.headers) {
      request.headers = {Authorization: `Bearer ${token}`};
    } else {
      request.headers.Authorization = `Bearer ${token}`;
    }
  }

  return request;
};

export const onError = (error, requestAction, {dispatch}) => {
  if (
    error.message === 'Network Error' &&
    !navigator.onLine &&
    requestAction.type !== getNotification.toString()
  ) {
    toast.error('Vous devez être en ligne pour consulter ce contenu', {
      toastId: 'offlineError',
    });
  }
  if (error && error?.request?.response) {
    let errorResponse;
    try {
      errorResponse = JSON.parse(error.request.response);
    } catch {
      throw error;
    }
    const errorCode = errorResponse?.error?.code || errorResponse?.code;
    const errorMessage = errorResponse?.error?.message || errorResponse?.message;
    const method = (requestAction?.request?.method || 'get').toLowerCase();

    if (DEV_MODE) {
      console.error(errorCode, errorMessage, `(${requestAction.type})`);
    }

    if (
      errorCode === 'jwt_auth_invalid_token' ||
      errorCode === 'jwt_auth_bad_iss' ||
      errorMessage === 'Expired token' ||
      errorMessage === 'The iss do not match with this server'
    ) {
      dispatch(deleteToken());
      dispatch(replace('/login'));
    } else if (method === 'get') {
      dispatch(push('/error'));
    } else if (method === 'delete') {
      toast.error(errorMessages.cantDelete);
    }
  }
  throw error;
};

export const onSuccess = (response, requestAction) => {
  const methods = ['post', 'put', 'patch', 'delete'];
  const method = (requestAction?.request?.method || '').toLowerCase();

  if (
    methods.includes(method) &&
    requestAction.type !== 'api/auth/auth/postAuth' &&
    requestAction.type !== 'api/register/register/postRegisterInfo' &&
    requestAction.type !== 'api/passwordReset/passwordReset/postPasswordReset' &&
    requestAction.type !== 'api/gifts/gifts/postVisibilityProof'
  ) {
    toast.success(successMessages[method]);
  }
  return response;
};
